import { Container, FormControl, Grid, Paper, TextField } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Route, Routes, useNavigate } from "react-router-dom";
import { IFilteringViewModel } from "../../_common/interface/table";
import StyledGrid from "../../_components/grid/styledGrid";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { eventDocumentTemplateService } from "../../_services/eventDocumentTemplate.service";
import { EventDocumentManage } from "../eventDocument/eventDocument-manage";
import { EventDocumentTemplateManageDrawer } from "./eventDocumentTemplate-manageDrawer";


export function EventDocumentTemplateIndex() {

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
    });

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
        ],
        [],
    );

    let navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {

        return eventDocumentTemplateService.getAll({ ...filter })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function handleChange(event: any) {
        setFilter((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };

    return (

        <Container>

            <PageHeader
                pageName="Event Document Template"
                buttonName="Event Document Template"
                onClick={() => navigate("Create")}
                actionType="create"
            />

            <Paper>

                <ValidatorForm onSubmit={fetchData}>

                    <StyledGrid container spacing={2}>

                        <Grid item lg={3} md={6} xs={12}>
                            <FormControl fullWidth>
                                <TextField label="Name" name="name" value={filter.name} onChange={handleChange} placeholder="Name" variant="outlined" />
                            </FormControl>
                        </Grid>

                    </StyledGrid>

                </ValidatorForm>

                <CommonTable
                    columns={columns}
                    data={data}
                    filter={filter}
                    onEdit={(id) => { navigate("Edit/" + id) }}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    isLoading={isLoading}
                />
            </Paper>

            <Routes>
                <Route path="/Create" element={<EventDocumentTemplateManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} />
                <Route path="/Edit/:eventDocumentTemplateId/" element={<EventDocumentTemplateManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} >
                    <Route path="EventDocuments" element={<EventDocumentManage emitOnSave={() => { }} />} />
                </Route>

            </Routes>
        </Container>


    );

}
